import AsyncStorage from "@react-native-async-storage/async-storage";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import useApi from "../../hooks/useAPI";
import { TOKEN_STORAGE_KEY } from "../api";
type student = "student" | "Estudante";
type guardian = "guardian" | "Responsável";
interface UserInfo {
  email: string;
  id: string;
  name: string;
  aggregate_users: User[];
  account_type: student | guardian
}

export interface MainUser {
  refresh_token: string;
  token: string;
  user_info: UserInfo;
}

export interface Card {
  city: string;
  course: string;
  cpf: string;
  dob: string;
  education_level: string;
  expiry: string;
  fesn_data: {
    error: any;
    fesn_id: string;
    fesn_national_id: string;
    fesn_qrcode_link: string;
    status: string;
  };
  image_id: string;
  institution: string;
  institution_id: string;
  isic_data: {
    error: any;
    isic_card_number: string;
    status: string;
  };
  name: string;
  rg: string;
  status: string;
  type_of_card: string;
  uf: string;
  images: {
    front: string;
  };
}

export interface User {
  name: string;
  city: string;
  course: string;
  cpf: string;
  card: Card;
  dob: string;
  education_level: string;
  id: string;
  institution: string;
  institution_id: string;
  main_user_id: string;
  position: string;
  profile_image_id: string;
  rg: string;
  uf: string;
  created_at: string;
  updated_at: string;
}

export interface AuthState {
  email: string;
  userInfo: UserInfo;
  token: string;
  refreshToken: string;
  auth: boolean;
  subUser?: User;
}
const initialState: AuthState = {
  email: "",
  userInfo: {
    email: "",
    id: "",
    name: "",
    aggregate_users: [],
  },
  token: "",
  refreshToken: "",
  auth: false,
};
export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state, action: PayloadAction<Partial<AuthState>>) => {
      return { ...state, ...action.payload };
    },
    update: (state, action: PayloadAction<Partial<AuthState>>) => {
      return { ...state, ...action.payload };
    },
    setSubUser: (state, action: PayloadAction<User>) => {
      return { ...state, subUser: action.payload };
    },
    setProfileImage: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        subUser: {
          ...state.subUser!,
          profile_image_id: action.payload,
        },
      };
    },
    setCard: (state, action: PayloadAction<Card>) => {
      return { ...state, subUser: { ...state.subUser!, card: action.payload } };
    },
    logout: () => {
      return initialState;
    },
  },
});
export const SAVED_USER_KEY = "@userInfo";
export const ACTIVE_USER_ID = "@activeUserId";
export const ALL_USER_INFO = "@allUserInfo";

export const { login, logout, setSubUser, setProfileImage, setCard } =
  authSlice.actions;

export const clearSavedUser = (dispatch: any) => async () => {
  try {
    await AsyncStorage.removeItem(SAVED_USER_KEY);
    await AsyncStorage.removeItem(TOKEN_STORAGE_KEY);
    await AsyncStorage.removeItem(ALL_USER_INFO);
    dispatch(logout());
  } catch (e) {
    console.log("Error getting saved user");
  }
};

export default authSlice.reducer;
